// Vladimir — Transfusion: drains the target for magic damage and heals himself.
// Every 3rd cast doubles both damage and healing.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const vladimirTransfusion: Ability = {
  id: "vladimirTransfusion",
  displayName: "Transfusion",
  description: "Deals 0.6× AP + 40 magic damage and heals for 60. Every 3rd cast doubles both.",
  iconId: "VladimirQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const empowered = caster.abilityCastCount > 0 && (caster.abilityCastCount + 1) % 3 === 0;
    const mult = empowered ? 2 : 1;
    const dmg = magicDamage(stats.ap * 0.6 * mult + 40 * mult);
    const healAmt = 60 * mult;

    return [
      { target, amount: dmg, type: "magical" },
      { target: caster, amount: 0, type: "none", heal: healAmt },
    ];
  },
};
